import { render, staticRenderFns } from "./Wp_mini_data_card.vue?vue&type=template&id=48031712&scoped=true&"
import script from "./Wp_mini_data_card.vue?vue&type=script&lang=js&"
export * from "./Wp_mini_data_card.vue?vue&type=script&lang=js&"
import style0 from "./Wp_mini_data_card.vue?vue&type=style&index=0&id=48031712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48031712",
  null
  
)

export default component.exports